import { Link, useLocation } from "react-router-dom";
import { toPersianNumber } from "../utils/persian";

const Pagination = ({ page, count, perPage, path }) => {
  const location = useLocation();
  const currentPage = parseInt(page) || 1;
  const totalLinks = Math.ceil(Number(count || 0) / Number(perPage || 1));

  if (totalLinks <= 1) {
    return null;
  }

  const makeUrl = (pageNumber) => {
    const query = location.search || "";
    return `/${path}/${pageNumber}${query}`;
  };

  const pages = [];

  for (let i = 1; i <= totalLinks; i++) {
    if (i === 1 || i === totalLinks || Math.abs(i - currentPage) <= 2) {
      pages.push(i);
    }
  }

  return (
    <nav className="shop-pagination" aria-label="صفحه‌بندی محصولات">
      <div className="shop-pagination-desktop">
        {currentPage > 1 && (
          <Link to={makeUrl(currentPage - 1)} className="shop-page-link shop-page-nav">
            قبلی
          </Link>
        )}

        {pages.map((item, index) => {
          const previous = pages[index - 1];
          const showDots = previous && item - previous > 1;

          return (
            <span className="shop-page-group" key={item}>
              {showDots && <span className="shop-page-dots">...</span>}

              <Link to={makeUrl(item)} className={`shop-page-link ${currentPage === item ? "active" : ""}`}>
                {toPersianNumber(item)}
              </Link>
            </span>
          );
        })}

        {currentPage < totalLinks && (
          <Link to={makeUrl(currentPage + 1)} className="shop-page-link shop-page-nav">
            بعدی
          </Link>
        )}
      </div>

      <div className="shop-pagination-mobile">
        <span className="shop-page-mobile-current">
          صفحه {toPersianNumber(currentPage)} از {toPersianNumber(totalLinks)}
        </span>

        {currentPage < totalLinks ? (
          <Link to={makeUrl(currentPage + 1)} className="shop-page-mobile-load">
            نمایش محصولات بیشتر
          </Link>
        ) : (
          <span className="shop-page-mobile-done">
            همه محصولات این بخش نمایش داده شد
          </span>
        )}

        {currentPage > 1 && (
          <Link to={makeUrl(currentPage - 1)} className="shop-page-mobile-back">
            بازگشت به صفحه قبل
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Pagination;
